// extracted by mini-css-extract-plugin
module.exports = {"circles":"circles-module--circles--hW7sA"};